import { createContext } from 'react';
export var Z_INDEX_ABOVE_DRAWER = 4102;
export default createContext(Z_INDEX_ABOVE_DRAWER);